import _regenerator from "/home/jenkins/agent/workspace/chongyueyuedsn29/cyy-manage-web-new/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/home/jenkins/agent/workspace/chongyueyuedsn29/cyy-manage-web-new/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _typeof from "/home/jenkins/agent/workspace/chongyueyuedsn29/cyy-manage-web-new/node_modules/@babel/runtime/helpers/esm/typeof.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
/**
 * 插件
 * */

// 错误捕获
import pluginError from '@/plugins/error';
// 日志插件
import pluginLog from '@/plugins/log';
// 鉴权指令
import directiveAuth from '@/plugins/auth';
import Tool from '@/utils/tool';
import { uuid } from '@/utils/common';
var styleDirective = {
  bold: {
    mounted: function mounted(el, binding) {
      if (Tool.isNotNull(binding.value)) {
        el.style.fontWeight = binding.value;
      } else {
        el.style.fontWeight = 'bold';
      }
    },
    updated: function updated(el, binding) {
      if (Tool.isNotNull(binding.value)) {
        el.style.fontWeight = binding.value;
      } else {
        el.style.fontWeight = 'bold';
      }
    },
    unmounted: function unmounted(el) {
      el.style.fontWeight = null;
    }
  },
  mt: {
    mounted: function mounted(el, binding) {
      if (Tool.isNotNull(binding.value)) {
        el.style.marginTop = binding.value + 'px';
      }
    },
    updated: function updated(el, binding) {
      if (Tool.isNotNull(binding.value)) {
        el.style.marginTop = binding.value + 'px';
      }
    },
    unmounted: function unmounted(el) {
      el.style.marginTop = null;
    }
  },
  mb: {
    mounted: function mounted(el, binding) {
      if (Tool.isNotNull(binding.value)) {
        el.style.marginBottom = binding.value + 'px';
      }
    },
    updated: function updated(el, binding) {
      if (Tool.isNotNull(binding.value)) {
        el.style.marginBottom = binding.value + 'px';
      }
    },
    unmounted: function unmounted(el) {
      el.style.marginBottom = null;
    }
  },
  mtb: {
    mounted: function mounted(el, binding) {
      if (Tool.isNotNull(binding.value)) {
        el.style.marginTop = binding.value + 'px';
        el.style.marginBottom = binding.value + 'px';
      }
    },
    updated: function updated(el, binding) {
      if (Tool.isNotNull(binding.value)) {
        el.style.marginTop = binding.value + 'px';
        el.style.marginBottom = binding.value + 'px';
      }
    },
    unmounted: function unmounted(el) {
      el.style.marginTop = null;
      el.style.marginBottom = null;
    }
  },
  ml: {
    mounted: function mounted(el, binding) {
      if (Tool.isNotNull(binding.value)) {
        el.style.marginLeft = binding.value + 'px';
      }
    },
    updated: function updated(el, binding) {
      if (Tool.isNotNull(binding.value)) {
        el.style.marginLeft = binding.value + 'px';
      }
    },
    unmounted: function unmounted(el) {
      el.style.marginLeft = null;
    }
  },
  mr: {
    mounted: function mounted(el, binding) {
      if (Tool.isNotNull(binding.value)) {
        el.style.marginRight = binding.value + 'px';
      }
    },
    updated: function updated(el, binding) {
      if (Tool.isNotNull(binding.value)) {
        el.style.marginRight = binding.value + 'px';
      }
    },
    unmounted: function unmounted(el) {
      el.style.marginRight = null;
    }
  },
  pt: {
    mounted: function mounted(el, binding) {
      if (Tool.isNotNull(binding.value)) {
        el.style.paddingTop = binding.value + 'px';
      }
    },
    updated: function updated(el, binding) {
      if (Tool.isNotNull(binding.value)) {
        el.style.paddingTop = binding.value + 'px';
      }
    },
    unmounted: function unmounted(el) {
      el.style.paddingTop = null;
    }
  },
  pl: {
    mounted: function mounted(el, binding) {
      if (Tool.isNotNull(binding.value)) {
        el.style.paddingLeft = binding.value + 'px';
      }
    },
    updated: function updated(el, binding) {
      if (Tool.isNotNull(binding.value)) {
        el.style.paddingLeft = binding.value + 'px';
      }
    },
    unmounted: function unmounted(el) {
      el.style.paddingLeft = null;
    }
  },
  pr: {
    mounted: function mounted(el, binding) {
      if (Tool.isNotNull(binding.value)) {
        el.style.paddingRight = binding.value + 'px';
      }
    },
    updated: function updated(el, binding) {
      if (Tool.isNotNull(binding.value)) {
        el.style.paddingRight = binding.value + 'px';
      }
    },
    unmounted: function unmounted(el) {
      el.style.paddingRight = null;
    }
  },
  pb: {
    mounted: function mounted(el, binding) {
      if (Tool.isNotNull(binding.value)) {
        el.style.paddingBottop = binding.value + 'px';
      }
    },
    updated: function updated(el, binding) {
      if (Tool.isNotNull(binding.value)) {
        el.style.paddingBottop = binding.value + 'px';
      }
    },
    unmounted: function unmounted(el) {
      el.style.paddingBottop = null;
    }
  },
  paddings: {
    mounted: function mounted(el, binding) {
      if (Tool.isNotNull(binding.value)) {
        if (_typeof(binding.value) === 'object') {
          el.style.padding = binding.value.map(function (item) {
            return item + 'px';
          }).join(' ');
        } else {
          el.style.padding = binding.value + 'px';
        }
      }
    },
    updated: function updated(el, binding) {
      if (Tool.isNotNull(binding.value)) {
        if (_typeof(binding.value) === 'object') {
          el.style.padding = binding.value.map(function (item) {
            return item + 'px';
          }).join(' ');
        } else {
          el.style.padding = binding.value + 'px';
        }
      }
    },
    unmounted: function unmounted(el) {
      el.style.padding = null;
    }
  },
  loading: {
    mounted: function () {
      var _mounted = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(el, binding) {
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              _context.n = 1;
              return handleLoading(el, binding);
            case 1:
              return _context.a(2);
          }
        }, _callee);
      }));
      function mounted(_x, _x2) {
        return _mounted.apply(this, arguments);
      }
      return mounted;
    }(),
    update: function () {
      var _update = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(el, binding) {
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              _context2.n = 1;
              return handleLoading(el, binding);
            case 1:
              return _context2.a(2);
          }
        }, _callee2);
      }));
      function update(_x3, _x4) {
        return _update.apply(this, arguments);
      }
      return update;
    }(),
    unmounted: function unmounted(el) {
      el.parentNode && el.parentNode.removeChild(el);
    }
  }
};
var handleLoading = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(el, binding) {
    var loadingId, loadingSpan;
    return _regenerator().w(function (_context3) {
      while (1) switch (_context3.n) {
        case 0:
          loadingId = el.getAttribute("loading-id");
          if (!loadingId) {
            loadingId = uuid();
          }
          loadingSpan = el.querySelector(".ivu-spin[data-id='" + loadingId + "']");
          if (binding.value) {
            if (!loadingSpan) {
              el.style.position = 'relative';
              el.setAttribute('loading-id', loadingId);
              loadingSpan = document.createElement('div');
              loadingSpan.setAttribute("data-id", loadingId);
              loadingSpan.className = "ivu-spin ivu-spin-default ivu-spin-fix";
              loadingSpan.innerHTML = "\n                    <div class=\"ivu-spin-main\">\n                      <span class=\"ivu-spin-dot\"></span>\n                      <div class=\"ivu-spin-text\"></div>\n                     </div>\n         ";
              el.appendChild(loadingSpan);
            }
          } else {
            loadingSpan && loadingSpan.remove();
          }
        case 1:
          return _context3.a(2);
      }
    }, _callee3);
  }));
  return function handleLoading(_x5, _x6) {
    return _ref.apply(this, arguments);
  };
}();
export default {
  install: function install(app, options) {
    return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
      return _regenerator().w(function (_context4) {
        while (1) switch (_context4.n) {
          case 0:
            // 插件
            app.use(pluginError);
            app.use(pluginLog);

            // 指令
            app.directive('auth', directiveAuth);
            Object.keys(styleDirective).forEach(function (key) {
              app.directive(key, styleDirective[key]);
            });
          case 1:
            return _context4.a(2);
        }
      }, _callee4);
    }))();
  }
};